var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidateLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00033 6.6665C5.46056 6.6665 5.83366 7.0396 5.83366 7.49984V14.9998C5.83366 15.4601 5.46056 15.8332 5.00033 15.8332C4.54009 15.8332 4.16699 15.4601 4.16699 14.9998V7.49984C4.16699 7.0396 4.54009 6.6665 5.00033 6.6665Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 7.49953C9.1665 7.03944 8.79347 6.6665 8.33333 6.6665C7.8731 6.6665 7.5 7.0396 7.5 7.49984V10.8332V14.9998C7.5 15.4601 7.8731 15.8332 8.33333 15.8332C8.79357 15.8332 9.16667 15.4601 9.16667 14.9998V10.8332C9.16667 9.45246 10.286 8.33317 11.6667 8.33317C13.0474 8.33317 14.1667 9.45246 14.1667 10.8332V14.9998C14.1667 15.4601 14.5398 15.8332 15 15.8332C15.4602 15.8332 15.8333 15.4601 15.8333 14.9998V10.8332C15.8333 8.53198 13.9679 6.6665 11.6667 6.6665C10.7287 6.6665 9.86305 6.97646 9.16667 7.49953Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 4.99984C5.83366 5.46007 5.46056 5.83317 5.00033 5.83317C4.54009 5.83317 4.16699 5.46007 4.16699 4.99984C4.16699 4.5396 4.54009 4.1665 5.00033 4.1665C5.46056 4.1665 5.83366 4.5396 5.83366 4.99984Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateLinkedin);
export default __webpack_public_path__ + "static/media/candidate-linkedin.01c23300a0a22ee4f2b6f610ada54160.svg";
export { ForwardRef as ReactComponent };